import React, { useEffect, useState } from 'react'

import Modal from '../reusable/modal'

import codeBlue from '../../sounds/code_blue.mp3'
import { setCodeBlue } from '../../store/actions'
import { useDispatch } from 'react-redux'

const CodeBlue = ({ alert }) => {
    let colourInterval, audioInterval
    const audio = new Audio(codeBlue)
    
    const [mask, setMask] = useState('red-600')

    const dispatch = useDispatch()

    const colours = ['red-700', 'blue-700']

    useEffect(() => {
        if (alert) {
            colourInterval = setInterval(() => {
                if (mask === colours[0])
                    setMask(colours[1])
                else
                    setMask(colours[0])
            }, 500)
            
            audioInterval = setInterval(() => {
                audio.play()
            }, 2000)
        } else {
            audio?.pause()
            colourInterval?.clearInterval()
            audioInterval?.clearInterval()
        }
    }, [alert])

    const close = () => dispatch(setCodeBlue())

    return (
        <Modal toggle={ close } w={ 400 } maskClasses={ `bg-${mask}`} maskClosable={ false } visible={ alert !== undefined }>
            <h1 className="text-3xl text-center font-extrabold">Code Blue</h1>
            <p className="text-3xl text-center font-extrabold">Code Blue Alert in { alert?.station }</p>
        </Modal>            
    )
}

// const useCodeBlue = () => {
//     const [mask, setMask] = useState('')

//     const { codeBlue } = useSelector(state => state.application)

//     const dispatch = useDispatch()

//     const pulseColors = () => {
//         const colors = ['#ff0000', '#ff7f00', '#ffff00', '#00ff00', '#0000ff', '#4b0082', '#800080']
//         let colorIndex = 0
    
//         return setInterval(() => {
//             const maskClasses = `mask-${colors[colorIndex]}`
//             // Assuming you have a reference to the modal component
//             modal.maskClasses = maskClasses
    
//             colorIndex = (colorIndex + 1) % colors.length
//         }, 500)
//     }

//     useEffect(() => {
        
//     }, [alert])
// }

export default CodeBlue